<template>
	<div class="VideoListBox" id="VideoListBoxs">
		<div class="common-header-wrap">
            <mt-header :title="videotitle" class="common-header">
                <mt-button slot="left" icon="back" @click="backoff()"></mt-button>
            </mt-header>
        </div>
        
        <div class="AddVideoBox">
        	<div class="filsscbox">
	        	<div class="AddVideoCoreBox">
	        		<div class="VideoImgBois">
	        			<img :src="manimg" />
	        		</div>
	        		<div class="VideoImgInputBox">
	        			<div class="filsBox">
	        				<span><i class="item-icon iconfont">&#xe639;</i>Video Cover</span>
	        				<input @change="uploadImage($event)" type="file" ref="imgfile" accept="image/*">
	        			</div>
	        		</div>
	        		<p>Suggest 600*600 pixels, or Any Squareness Ratio size</p>
	        	</div>
	        	
	        	<div class="AddVideoCoreBox">
	        		<div class="VideoImgBois">
	        			<video v-show="videoBoxshow" class="videoshowsss" :src="videos" muted loop="loop" controls="controls" x5-playsinline="" playsinline="true" webkit-playsinline="true" x-webkit-airplay="true" x5-video-player-type="h5" x5-video-player-fullscreen="" x5-video-orientation="portraint" controlslist="nodownload nofullscreen noremoteplayback noplaybackrate"></video>
	        		</div>
	        		<div class="VideoImgInputBox">
	        			<div class="filsBox"  v-show="videoshow">
	        				<span><i class="item-icon iconfont">&#xe639;</i>Upload Video</span>
	        				<input @change="uploadVideo($event)" type="file" ref="videofile" accept="video/*">
	        			</div>
	        		</div>
	        		<p>Only MP4 flie format is supported, suggust file under 30MB.</p>
	        	</div>	
        	</div>
        	
        	
        	<div class="inputlist">
		    	<div class="inputbox">
		    		<div class="inputboxspan">
		    			<span>Title</span>
		    		</div>
		    		<div class="inputboxval">
		    			<input type="text" maxlength="30" v-model="svideo_name" placeholder="Required, limited to 30 characters"/>
		    		</div>
		    	</div>
		    	
		    	<div class="inputbox">
		    		<div class="inputboxspan inputboxspantwo">
		    			<span>Video introduction</span>
		    		</div>
		    		<div class="inputboxval">
		    			<textarea placeholder="Optional, limited to 200 characters" v-model="svideo_intro" maxlength="200"></textarea>
		    		</div>
		    	</div>
		    	
		    	<!--<div class="inputbox">
		    		<div class="inputboxspan">
		    			<span>产品链接(选填)</span>
		    		</div>
		    		<div class="inputboxval">
		    			<input class="store_ids" v-model="goods_id" type="text" placeholder="如https://h5.duoyp.com/home/goodsdetail?goods_id=24874"/>
		    		</div>
		    	</div>-->
		    	
		    	<div class="inputbox">
		    		<div class="inputboxspan">
		    			<span>Video tag</span>
		    		</div>
		    		<div class="inputboxval taglist" @click="tagshow">
		    			<p>
		    				<span v-for="(item,index) in checktag">#{{item.svideotag_name}}</span>
		    			</p>
		    			
		    		</div>
		    	</div>
		    </div>
		    <div class="VideoSetts">
		    	<div class="VideoSettsTitle">
		    		<p>Settings</p>
		    	</div>
		    	<div class="settings">
			    	<div class="VideoSettsBox">
			    		<div class="VideoSettsboxspan">
			    			<span>Top Video</span>
			    		</div>
			    		<div class="VideoSettsVal">
			    			<label>
								<input type="radio" name="svideo_top" v-model="svideo_top" value="1">
								<span>Top Video</span>
							</label>
							
							<label>
								<input type="radio" name="svideo_top" v-model="svideo_top" value="0">
								<span>No</span>
							</label>
			    		</div>
			    	</div>
			    	
			    	<div class="VideoSettsBox">
			    		<div class="VideoSettsboxspan">
			    			<span>Public</span>
			    		</div>
			    		<div class="VideoSettsVal">
			    			<label>
								<input type="radio" name="svideo_open" v-model="svideo_open" value="1">
								<span>Public</span>
							</label>
							
							<label>
								<input type="radio" name="svideo_open" v-model="svideo_open" value="0">
								<span>Privacy</span>
							</label>
			    		</div>
			    	</div>
			    	

		    	</div>
		    	
		    </div>
		    <div class="ismaobotton">
				<span @click="submitaddvideo">Submit</span>
			</div>
        </div>
        
        
        <div class="AddTagBoxBacks" v-show="tagbox" @click="taghide"></div>
        <div class="AddTagBoxs" v-show="tagbox">
        	<div class="Addtitles">
        		<p>Add Tag</p>
        	</div>
        	<div class="AddTagContents">
        		<p></p>
        		<div class="TaglistBoxs yiyoutag">
        			<p class="LabelTitle">Tag List</p>
        			<span class="tips">Select tags for your video.</span>
        			<div class="Tagboxlist">
        				<span class="custom" @click="addtag">+Custom</span>
        				<span v-for="(item,index) in systag" @click="systagclick(item.tagname)">#{{item.tagname}}</span>
        				<span v-for="(item,index) in usertag" @click="usertagclick(item.svideotag_id,item.svideotag_name)">#{{item.svideotag_name}}</span>
        				
        			</div>
        		</div>
        		
        		<div class="TaglistBoxs">
        			<p class="LabelTitle">Selected Tag</p>
        			<span class="tips">Click the tag to delete</span>
        			<div class="Tagboxlist">
        				<span  v-for="(item,index) in hastag" @click="yiyoutag(item.svideotag_id,item.svideotag_name,index)">#{{item.svideotag_name}}</span>
        			</div>
        		</div>
        	</div>
        	<div class="TagBottoms">
        		<span @click="taghide">Cancel</span>
        		<span class="submitadd" @click="submittag">Submit</span>
        	</div>
        </div>
        
        <div class="AddTagBoxBack" @click="closeadd" v-show="AddTagBox"></div>
        <div class="AddTagBox"  v-show="AddTagBox">
        	<div class="Addtitle">
        		<p>Add Tag</p>
        	</div>
        	<div class="AddTagContent">
        		<input type="text" name="svideotag_name" v-model="svideotag_name" placeholder="Please enter tag title">
        		<!--<input type="text" name="svideotag_desc" v-model="svideotag_desc" placeholder="Please enter description">-->
        	</div>
        	<div class="TagBottom">
        		<span  @click="closeadd">Cancel</span>
        		<span class="submitaddss" @click="submitadd">Submit</span>
        	</div>
        </div>
        
	</div>
</template>

<script>
	import { getTagList,getsystag,getVideoinfo,endvideos,getisVideoMan,addTagList} from '../../../api/video'
	import { mapState } from 'vuex'
	import { Toast,MessageBox,Indicator } from 'mint-ui'
export default {
  name: 'video_list',
  data () {
    return {
      videoid:this.$route.query.videoid,	
      videotitle:"Upload Video",
      member_id:"",
      videoshow:true,
      tagbox:false,
      videoBoxshow:false,
      page:0,
      manimg:"https://www.duoyp.com/uploads/home/common/default_goods_image.jpg",
      videos:"",
      svideo_name:"",
      svideo_intro:"",
      tag_id:"",
      svideo_top:0,
      svideo_open:1,
      svideo_sort:0,
      pictype:0,
      videotype:0,
      video_list:"",
      systag:[{"tagids":"","tagname":"Sign Production"},{"tagids":"","tagname":"Laser Engraving"},{"tagids":"","tagname":"Signage"},{"tagids":"","tagname":"Digital Printing"},{"tagids":"","tagname":"Textile Printing"},{"tagids":"","tagname":"Retial Display"},{"tagids":"","tagname":"LED Displays"},{"tagids":"","tagname":"Digital Signage"},{"tagids":"","tagname":"LED Lighting"},{"tagids":"","tagname":"Stage Entertainment"}],
      usertag:"",
      hastag:[],
      checktag:"",
      tagids:"",
      svideotag_name:"",
      svideotag_desc:"",
      AddTagBox:false,
    }
  },
  
  components: {
    
  },
  mounted () {
	window.scrollTo(0,0);
  },
  created: function () {
	
  	if(this.user){
  		getisVideoMan(this.user.member_id,this.token).then((res) => {
			if(res.result.isman>0){
				if(this.videoid){
		  			this.videotitle="Edit Video";
		  			this.videoBoxshow=true;
		  			this.detailvideo()
		  		}
		  		this.getTagList();
			}else{
				this.$router.push({ name: 'MemberVideoIndex',query: { gologin: "1" }})
			}
	  })
  	}
    
  },
  computed: {
    ...mapState({
    	isOnline: state => state.member.isOnline,
    	user: state => state.member.info,
    	token: state => state.member.token
    })
  },
  methods: {
  	//获取视频信息
  	detailvideo:function(){
  		endvideos(this.videoid,this.user.member_id,this.token).then(res=>{
  			if(res.code==10000){
				this.videoshow=false;
  				this.manimg=res.result.video_info.svideo_pic;
  				this.videos=res.result.video_info.svideo_url;
  				this.svideo_name=res.result.video_info.svideo_name;
  				this.svideo_intro=res.result.video_info.svideo_intro;
  				this.svideo_top=res.result.video_info.svideo_top;
  				this.svideo_open=res.result.video_info.svideo_open;
  				this.svideo_sort=res.result.video_info.svideo_sort;
  				this.checktag=res.result.videocontag_list;
  				this.hastag=res.result.videocontag_list;
  				
  				
  			}
  		}).catch(function (error) {
	        Indicator.close()
	        Toast(error.message)
	    })
  	},
  	
  	//提交
  	submitaddvideo:function(){
  		if(this.svideo_name==""){
  			Toast("Video Title");
  			return false;
  		}else if(this.manimg=="https://www.duoyp.com/uploads/home/common/default_goods_image.jpg"){
  			Toast("Please upload the video cover.");
  			return false;
  		}else if(this.videos==""){
  			Toast("Please upload the video.");
  			return false;
  		}else if(this.svideo_intro==""){
  			Toast("Video Description");
  			return false;
  		}else{
  			Indicator.open()
  			const imgfiles = this.$refs.imgfile.files[0]
  			const videofiles = this.$refs.videofile.files[0]
  			//获取视频标签
  			var taglistid="";
	  		for(var i=0;i<this.checktag.length;i++){
	  			var ids=this.checktag[i].svideotag_id;
				taglistid+=ids+',';
	  		}
	  		taglistid=taglistid.substring(0,taglistid.length-1);
  			
	      	const formFile = new FormData()
	      	formFile.append("svideo_id",this.videoid);
	      	formFile.append('videopic', imgfiles);
	      	formFile.append("videourl", videofiles);
	      	formFile.append("svideo_name", this.svideo_name);
			formFile.append("svideo_pic_source",this.pictype);
			formFile.append("svideo_source", this.videotype);
			formFile.append("svideo_intro", this.svideo_intro);			
			formFile.append("svideo_top", this.svideo_top);
			formFile.append("svideo_open", this.svideo_open);
			formFile.append("svideo_sort", this.svideo_sort);
			formFile.append("tag_id", taglistid);
			formFile.append('member_id', this.user.member_id);
	      	formFile.append('key', this.token);
			getVideoinfo(formFile).then((res) => {
				Indicator.close()
				Toast(res.message);
				if(res.code==10000){
					this.$router.push({ name: 'HomeVideoList'})
				}else{
//					Toast("保存失败！")
				}
				
		   	}).catch(function (error) {
		        Indicator.close()
		        Toast(error.message)
		    })
  		}
  	},
  	
  	//获取用户标签
    getTagList () {
      getTagList("1",this.user.member_id,this.token).then(res => {
      	this.usertag=res.result.tag_list;
      })
    },
  	//点击系统标签时，获取系统标签id
  	systagclick:function(tagname){
  		var an=1;
  		for(var i=0;i<this.hastag.length;i++){
  			if(this.hastag[i].svideotag_name==tagname){
  				Toast("This tag has already linked.");
  				an=2;
  				break;
  			}
  		}
  		if(an==1){
  			getsystag(tagname,this.user.member_id,this.token).then(res=>{
	  			if(res.code==10000){
	  				var tagjson={"svideotag_id":res.result,"svideotag_name":tagname}
	  				this.hastag=this.hastag.concat(tagjson);
	  				
	  			}else{
	  				Toast("Failed to add system label, please try again!");
	  			}
	  		})
  		}
  		
  		
  		
  	},
  	//点击用户标签时
  	usertagclick:function(tagid,tagname){
  		var an=1;
  		for(var i=0;i<this.hastag.length;i++){
  			if(this.hastag[i].svideotag_name==tagname){
  				Toast("This tag has already linked.");
  				an=2;
  				break;
  			}
  		}
  		if(an==1){
  			var tagjson={"svideotag_id":tagid,"svideotag_name":tagname}
  			this.hastag=this.hastag.concat(tagjson)
  		}
  	},
  	//删除视频标签
  	yiyoutag:function(tagid,tagname,index){ 		
  		this.hastag.splice[index,index]
  		this.$delete(this.hastag,index)
  	},
  	//选择标签确定
  	submittag:function(){
  		this.checktag=this.hastag;
  		this.tagbox=false;
  	},
  	//显示视频标签选择
  	tagshow:function(){
  		this.tagbox=true;
  	},
  	//关闭视频标签选择
  	taghide:function(){
  		this.tagbox=false;
  	},
  	 //本地上传图片并预览
  	uploadImage:function(e){
      let file=e.target.files[0];
      var sizes=e.target.files[0].size/1048576;
      if(sizes>3){
      	Toast("Please keep the image under 3MB.");	
      	this.$refs.imgfile.value='';
      }else{
      	let img=new FileReader();
	    img.readAsDataURL(file);
	    img.onload=({ target }) => {
	        this.manimg=target.result;
	    };
      }
      
   },
   //本地上传视频并且预览
   uploadVideo:function(e){
   	   this.videoBoxshow=true;
      let file=e.target.files[0];
      var fileName=e.target.files[0].name
      var fileType = fileName.substr(fileName.lastIndexOf(".")).toUpperCase();
      var sizes=Math.floor(e.target.files[0].size/1048576);
      if(fileType==".mp4" || fileType==".MP4"  || fileType==".mov"  || fileType==".MOV"){
      	if(sizes>31){
      		Toast("Please keep the video less than 30MB.");	
      		this.$refs.videofile.value='';
      	}else{
      		let img=new FileReader();
		    img.readAsDataURL(file);
		    img.onload=({ target }) => {
		        this.videos=target.result;
		    };
      	}
      }else{
      	Toast("Please use MP4 video format.");
      	this.$refs.videofile.value='';
    }
   },
   //返回上一页
   backoff:function(){
   	var gologin=this.$route.query.gologin;
   	if(gologin && gologin!=undefined){
   		this.$router.push({ name: 'MemberIndex' })
   	}else{
   		this.$router.go(-1);
   	}
   },
   //添加标签弹窗
    addtag:function(){
    	this.tagids="";
    	this.svideotag_name="";
	    this.svideotag_desc="";
    	this.AddTagBox=true;
    },
    //关闭新增弹窗
    closeadd:function(){
    	this.AddTagBox=false;
    },
    //标签提交
  	submitadd:function(){
  		if(this.svideotag_name==""){
  			Toast("Please enter tag title.");
  		}else{
  			addTagList(this.tagids,this.svideotag_name,this.svideotag_desc,this.user.member_id,this.token).then(res => {
		      	if(res.code==10000){
		      		var tagjson={"svideotag_id":res.result,"svideotag_name":this.svideotag_name}
  					this.hastag=this.hastag.concat(tagjson);
		      		this.closeadd();
		      	}else{
		      		
		      	}
		      	Toast(res.message)
		    })
  		}
  	},
  }
}		
</script>


<style lang="scss" scoped>
.AddVideoBox{background: #fff;padding-bottom: 3rem;}
.filsscbox{background-color: #fcfcfc;padding: 0 0.3rem;}
.AddVideoCoreBox {padding: 0.3rem 0.3rem;text-align: center;border-bottom: 1px solid #ddd;}
.VideoImgBois{display: inline-block;width: 5rem;height: 5rem;border: 1px solid #ddd;line-height: 4.8rem;box-sizing: border-box;text-align: center;overflow: hidden;vertical-align: middle;position: relative;}
span.tips{font-size: 0.3rem;color: #888;display: inline-block;margin-left: 0.3rem;}
.VideoImgBois img{max-width: 100%;max-height: 100%;}
.VideoImgBois video{width: 100%;height: 100%;box-sizing: border-box;}
.VideoImgInputBox{display: inline-block;vertical-align: middle;width: calc(100% - 6rem);}
.AddVideoCoreBox p{color: #888;margin-top: 0.5rem;font-size: 0.5rem;text-align: left;padding-left: 0.3rem;}
.filsBox{position: relative;display: inline-block;}
.filsBox span{display: inline-block;display: inline-block; line-height: 1.5rem; padding: 0 0.5rem; box-sizing: border-box; background: #f5f5f5; border-radius: 3px; font-size: 0.7rem; color: #333; margin: 5px 0; border: 1px solid #ddd;min-width: 5rem;}
.filsBox input{position: absolute;left: 0px;top: 0px;width: 100%;height: 100%;z-index: 9;opacity: 0;}
.inputlist{background: #fff;padding: 0 0.3rem;padding-right: 0rem;}
.inputbox {border-bottom: 1px solid #d9d9d9;padding: 0.3rem 0 0.2rem 0;}
.inputboxspan{display: inline-block;vertical-align: middle;width: 4.5rem;}
.inputboxspan span{font-size: 0.7rem;color: #000;line-height: 1.5rem;font-weight: bold;}
.inputboxspantwo span{line-height: 0.7rem;}
.inputboxval{display: inline-block;vertical-align: middle;width: calc(100% - 5rem);display: inline-block;}
.inputboxval input{line-height: 1.5rem;font-size: 0.7rem;color: #333;display: inline-block;width: 100%;outline: none;border: none;background-color: #f2f2f2;box-sizing: border-box;padding: 0 0.2rem;}
.inputboxval input.store_ids{font-size: 0.3rem;}
.inputboxval textarea{line-height: 1.3rem;font-size: 0.7rem;color: #333;display: inline-block;width: 100%;outline: none;border: none;height: 5rem;resize: none;font-family: "微软雅黑";background-color: #f2f2f2;box-sizing: border-box;padding: 0 0.2rem;}
.ismaobotton{text-align: center;}
.ismaobotton span{display: inline-block;border: none;line-height: 1.6rem;padding: 0.3rem 3rem;font-size: 0.8rem;color: #fff;background: #e93b3d;margin-top: 2rem;border-radius: 5px;min-width: 80%;box-sizing: border-box;}
.VideoSettsTitle{padding: 0 0.2rem;margin-top: 0.6rem;}
.VideoSettsTitle p{font-size: 0.7rem;color: #000;font-weight: bold;line-height: 1rem;}
.VideoSettsBox{padding: 0 0.3rem;margin-top: 0.2rem;}
.VideoSettsboxspan{display: inline-block;vertical-align: middle;width: 4rem;}
.VideoSettsboxspan span{font-size: 0.7rem;color: #000;line-height: 1.5rem;font-weight: bold;}
.VideoSettsVal{display: inline-block;vertical-align: middle;width: calc(100% - 5rem);display: inline-block;}
.VideoSettsVal label{display: inline-block;margin-right: 1rem;cursor: pointer;}
.VideoSettsVal label input{width: 0.8rem;height: 0.8rem;vertical-align: middle;display: inline-block;margin-right: 0.2rem;}
.VideoSettsVal label span{font-size: 0.7rem;}
.settings{padding: 0.3rem 0.5rem;}
.paixhaol .VideoSettsVal input{line-height: 1.5rem;font-size: 0.7rem;color: #333;display: inline-block;width: 5rem;outline: none;border: 1px solid #ddd;box-sizing: border-box;padding: 0 0.2rem;text-align: center;border-radius: 5px;}
.taglist{min-height: 1.5rem;}
.taglist span{font-size: 0.6rem;color: #333;line-height: 1.5rem;display: inline-block;margin-right: 0.4rem;}
.taglist p{}
.AddTagBoxBacks{position: fixed;z-index: 99;left: 0px;top: 0px;width: 100%;height: 100%;background: rgba(0,0,0,0.2);}
.AddTagBoxs{position: fixed;z-index: 1000;left: 5%;top: 10%;width: 90%;min-height: 5rem;background: #fff;border-radius: 10px;box-sizing: border-box;padding: 0;overflow: hidden;}
.Addtitles p{line-height: 1.8rem;text-align: center;font-size: 0.8rem;margin: 0;}
.Addtitles{border-bottom: 1px solid #ddd;padding: 0.1rem 0;}
.AddTagContents{padding: 0.2rem 0.1rem;}
.AddTagContents input{outline: none;border:1px solid #ddd;line-height: 1.8rem;box-sizing: border-box;padding: 0 0.2rem;border-radius: 0.3rem;display: inline-block;width: 100%;margin-top: 0.5rem;}
.TagBottoms{text-align: center;overflow: auto;overflow: auto;margin-top: 0.5rem;}
.TagBottoms span{display: inline-block;width: 50%;float: left;font-size: 0.9rem;line-height: 2.2rem;text-align: center;box-sizing: border-box;}
.TagBottoms span:nth-child(1){border-right: 1px solid #eee;background: #eee;}
.TagBottoms span.submitadd{background: #F01414;color: #fff;}
.TaglistBoxs .LabelTitle{display: inline-block; padding: 0.2rem 0.3rem; background: #f43434; font-size: 0.6rem; margin: 0; color: #fff; margin: 0; line-height: 1rem;}
.Tagboxlist{border: 1px solid #f43434;min-height: 4rem;max-height: 7rem;overflow: auto;padding: 0.2rem 0;}
.Tagboxlist span{display: inline-block; background: #FEF6CE; outline: 1px solid #EAD483; font-size: 0.5rem; line-height: 1rem; color: #555; border: 1px solid #FFF; padding: 0 0.3rem; box-sizing: border-box; margin: 0.1rem 0; cursor: pointer; position: relative;margin-left: 0.4rem;}
.Tagboxlist span.custom{background-color: #fff;border: 1px dashed #888;outline:none;}
.yiyoutag .LabelTitle{background: #bdbdbd;color: #333;}
.yiyoutag .Tagboxlist{border-color: #bdbdbd;}
.yiyoutag{margin-bottom: 0.6rem;}
.AddTagBoxBack{position: fixed;z-index: 9999;left: 0px;top: 0px;width: 100%;height: 100%;background: rgba(0,0,0,0.2);}
.AddTagBox{position: fixed;z-index: 10000;left: 10%;top: 20%;width: 80%;min-height: 5rem;background: #fff;border-radius: 10px;box-sizing: border-box;padding: 0;overflow: hidden;}
.Addtitle p{line-height: 1.8rem;text-align: center;font-size: 0.9rem;margin: 0;}
.Addtitle{border-bottom: 1px solid #ddd;padding: 0.1rem 0;}
.AddTagContent{padding: 0.2rem 0.5rem;}
.AddTagContent input{outline: none;border:1px solid #ddd;line-height: 1.8rem;box-sizing: border-box;padding: 0 0.2rem;border-radius: 0.3rem;display: inline-block;width: 100%;margin-top: 0.5rem;}
.TagBottom{text-align: center;overflow: auto;overflow: auto;margin-top: 0.5rem;}
.TagBottom span{display: inline-block;width: 50%;float: left;font-size: 0.9rem;line-height: 2.2rem;text-align: center;box-sizing: border-box;}
.TagBottom span:nth-child(1){border-right: 1px solid #eee;background: #eee;}
.TagBottom span.submitaddss{background: #F01414;color: #fff;}



</style>